// PopupComponent.jsx
import React from 'react';
import { GrInProgress } from "react-icons/gr";
import './PopupComponent.scss';

const PopupComponent = ({ onClose, onOutsideClick }) => {
  // Call the onOutsideClick when the area outside of the popup is clicked
  const handleOutsideClick = (e) => {
    if (e.target.id === 'popup-background') {
      onOutsideClick();
    }
  };

  return (
    <div id="popup-background" className="popup-background" onClick={handleOutsideClick}>
      <div className="popup-container">
        <div className="popup-header">upload files</div>
        <div className="progress-container">
          {/* This is where you'd integrate a circular progress bar component */}          
          <div className="progress-circle"> <GrInProgress /> </div>
        </div>
        <button className="popup-button" onClick={onClose}>cancel upload</button>
      </div>
    </div>
  );
};

export default PopupComponent;

/*il faudra voir dans EtapQuatre au dossier SousEtap au fichier Pupup afin de l'utiliser*/
